
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC"}},[_c('path',{attrs:{"d":"M22.992 26.72c2.22-4.792 4.724-7.013 7.028-8.133 1.873-.91 3.836-1.212 5.927-1.305l-2.842 2.842 3.356 3.355 9.463-9.463-9.463-9.463-3.356 3.355 3.544 3.544c-2.709.055-5.956.355-9.166 1.916-3.88 1.886-7.334 5.412-10.041 11.542-3.525 7.98-9.833 9.743-13.615 9.881v5.806c4.4-.118 10.824-1.808 15.616-7.815 3.12 3.663 5.803 5.063 7.685 5.978 3.21 1.56 6.457 1.86 9.166 1.916L32.75 44.22l3.356 3.356 9.464-9.464-9.464-9.464-3.356 3.356 2.843 2.842c-2.092-.093-4.056-.395-5.928-1.305-1.558-.757-4.913-4.37-6.673-6.821"}}),_c('path',{attrs:{"d":"M18.267 18.089c-4.634-5.315-10.779-6.848-14.962-6.96v5.805c3.227.118 8.33 1.419 11.913 6.755q.101-.216.2-.439c.875-1.981 1.829-3.691 2.85-5.161"}})]),_c('path',{staticClass:"i-arrow",attrs:{"stroke":"#234652","d":"M28.269 16.229c-2.389 1.16-4.99 3.505-7.27 8.667C16.333 35.46 7.605 38.091 2.076 38.239v-5.805c3.781-.139 10.09-1.901 13.614-9.882 2.708-6.13 6.162-9.656 10.042-11.542 3.21-1.56 6.457-1.86 9.166-1.916L31.354 5.55l3.355-3.355 9.464 9.463-9.464 9.464-3.355-3.356 2.842-2.842c-2.091.093-4.055.395-5.927 1.305Z"}}),_c('path',{staticClass:"i-arrow-tail",attrs:{"stroke":"#234652","d":"M16.563 15.529C11.99 10.639 6.117 9.204 2.076 9.095v5.806c3.116.114 7.983 1.33 11.54 6.22"}}),_c('path',{staticClass:"i-arrow-head",attrs:{"stroke":"#234652","d":"M23.558 27.17c1.564 2.143 3.181 3.372 4.71 4.115 1.873.91 3.837 1.212 5.928 1.305l-2.842-2.842 3.355-3.355 9.464 9.462-9.464 9.463-3.355-3.355 3.544-3.544c-2.71-.055-5.957-.355-9.166-1.915-1.919-.933-3.733-2.266-5.405-4.117"}})])
          )
        }
      }
    